import { useEffect, useRef } from 'react';
import Icon from './Icon';

const NAV = 'grid size-11 place-items-center rounded-full bg-white/15 text-white backdrop-blur disabled:opacity-30';

// Full-screen view of a meal's photos, over whatever sheet opened it (a modal dialog sits in the top layer).
// `index` is the photo shown, null when closed; arrows and the ←/→ keys move between photos.
export default function PhotoViewer({ photos, index, onChange, onClose }) {
  const ref = useRef(null);
  const open = index != null && !!photos[index];
  const openRef = useRef(open);
  openRef.current = open;

  useEffect(() => {
    const dialog = ref.current;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'ArrowLeft' && index > 0) onChange(index - 1);
      if (e.key === 'ArrowRight' && index < photos.length - 1) onChange(index + 1);
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, index, photos.length, onChange]);

  const photo = open ? photos[index] : null;
  return (
    // Escape closes only the viewer: handle it here rather than letting the browser close the dialogs.
    <dialog ref={ref} aria-label="Xem ảnh" onClose={(e) => { e.stopPropagation(); if (openRef.current) onClose(); }}
      onCancel={(e) => { e.preventDefault(); e.stopPropagation(); onClose(); }}
      className="m-0 max-h-none max-w-none bg-transparent p-0 backdrop:bg-black">
      {photo && (
        <div className="pt-safe pb-safe fixed inset-0 flex flex-col bg-black">
          <div className="flex items-center justify-between p-3">
            <span className="tabular text-sm text-white/80">{photos.length > 1 ? `${index + 1}/${photos.length}` : ''}</span>
            <button type="button" className={NAV} aria-label="Đóng ảnh" onClick={onClose}>
              <Icon name="x" className="size-6" />
            </button>
          </div>
          {/* Tapping the dark area around the photo closes it, like the backdrop of a sheet. */}
          <div className="flex min-h-0 flex-1 items-center justify-center px-2" onClick={(e) => e.target === e.currentTarget && onClose()}>
            <img src={photo.url} alt={`Ảnh bữa ăn ${index + 1}`} className="size-full object-contain" />
          </div>
          {photos.length > 1 && (
            <div className="flex items-center justify-center gap-6 p-4">
              <button type="button" className={NAV} aria-label="Ảnh trước" disabled={index === 0} onClick={() => onChange(index - 1)}>
                <Icon name="chevronLeft" className="size-6" />
              </button>
              <button type="button" className={NAV} aria-label="Ảnh sau" disabled={index === photos.length - 1} onClick={() => onChange(index + 1)}>
                <Icon name="chevronRight" className="size-6" />
              </button>
            </div>
          )}
        </div>
      )}
    </dialog>
  );
}
